import ExecutiveBriefingModule from './ExecutiveBriefingModule';

export default function ExecutiveBriefingTextile({ user }) {
  return (
    <ExecutiveBriefingModule 
      user={user} 
      moduleName="Textile Design"
      moduleTitle="Textile Design"
    />
  );
}
